import router from '@/router'
import i18n from '@/i18n'
export default {
  install(Vue) {
    Vue.prototype.$l = (key) => {
      const funcID = router.app.$route.meta.funcID
      var value
      if (key.startsWith('INDEX')) {
        value = i18n._t(key, i18n.locale, i18n._getMessages())
      } else {
        value = i18n._t(`${funcID}.${key}`, i18n.locale, i18n._getMessages())
      }
      if (value === key) {
        return null
      }
      return value
    }
  },
}
